'use strict';

const transformTransition = (theme) => `transform ${theme.transition.timings.fast} ${theme.transition.functions.easeFn}`;
const drawerTokens = (theme) => ({
    drawerZIndex: theme.zIndices.drawer,
    drawerOpenedTransition: transformTransition(theme),
    drawerClosedTransition: [
        transformTransition(theme),
        `visibility 0s ${theme.transition.timings.fast} ${theme.transition.functions.easeFn}`,
    ].join(', '),
    drawerBorder: `1px solid ${theme.colors.border}`,
    drawerBackground: theme.colors.body.background,
    drawerWidth: '50%',
    drawerMaxWidth: '720px',
    // tablet
    drawerTabletWidth: '100%',
    drawerTabletMaxWidth: '100%',
    // header
    drawerHeaderPaddingY: theme.space.component.y.m,
    drawerHeaderPaddingX: theme.space.component.x.l,
    // body
    drawerBodyPaddingY: theme.space.component.y.m,
    drawerBodyPaddingX: theme.space.component.x.m,
    drawerCloseIconPaddingY: theme.space.component.y.s,
    drawerCloseIconPaddingX: theme.space.component.x.s,
});

exports.drawerTokens = drawerTokens;
//# sourceMappingURL=drawer.js.map
